import { services } from "../data/services";
import { citiesByProvince } from "../data/cities";
import { getHead } from "../seo/routes";
import { cityIntro, cityLocalContext, cityCta, cityFaqs } from "../seo/content";
import { Seo } from "../components/Seo";
import { PageHero, Prose, FAQBlock, CTABand, Breadcrumbs, LinkGrid } from "../components/Blocks";

export default function CityPage({ city, province }) {
  const path = `/security-guards-${city.slug}`;
  const faqs = cityFaqs(city, province);
  const head = getHead(path, { faqs });
  const nearby = citiesByProvince(province.slug).filter((c) => c.slug !== city.slug);
  return (
    <>
      <Seo title={head.title} description={head.description} path={path} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Service Areas", to: "/service-areas" }, { label: province.name, to: `/security-guards-${province.slug}` }, { label: city.name }]} />
      <PageHero
        overline={`Security Guard Company · ${city.name}, ${province.abbr}`}
        title={`Security Guard Services in ${city.name}`}
        lead={`Licensed security guards, mobile patrol, event security and 24/7 alarm response across ${city.region} — verified coverage from Maze Security Solutions.`}
      />
      <Prose paragraphs={[cityIntro(city, province), cityLocalContext(city, province), cityCta(city)]} />
      <LinkGrid
        overline="Local Services"
        title={`Security Services Available in ${city.name}`}
        cols="grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
        items={services.map((s) => ({ to: `/${s.slug}-in-${city.slug}`, label: s.name, testid: `city-service-${s.slug}` }))}
      />
      <FAQBlock faqs={faqs} heading={`Security Services in ${city.name} — FAQs`} />
      {nearby.length > 0 && (
        <LinkGrid
          overline="Nearby"
          title={`Security Guards in Other ${province.name} Cities`}
          items={nearby.map((c) => ({ to: `/security-guards-${c.slug}`, label: c.name, testid: `nearby-city-${c.slug}` }))}
        />
      )}
      <CTABand title={`Get Guards on Your ${city.name} Property`} sub="Call our 24/7 dispatch line or email the coordination team. Urgent coverage — fire watch, alarm response — can often start the same day." />
    </>
  );
}
